import {Integer} from 'platform/foundation';

import {UserSidebarIconSize} from '@dms/api/shared';

export const SIDEBAR_DESKTOP_MENU_ICON_SIZE: Record<UserSidebarIconSize, Integer> = {
  default: 4,
  large: 5,
};
